export default __webpack_public_path__ + "static/media/logo_vector.26339407.svg";